module.exports = __webpack_public_path__ + "static/media/004.28636d50.jpg";